export default __webpack_public_path__ + "static/media/content-rigor-and-relevance.2641d0c0.png";